/* KANON `Programy v2 - D3 (0.8)` — what a TEMPLATE row adds to the shared anatomy.
 *
 * Everything a template row has in common with a client's plan is in `listRow.module.css`: the grid
 * shell, the selection, the stretched link, the cover and its category rule, the name over its
 * sub-line, the mode mark. What is left here is this row's own two facts.
 *
 * Read off the rendered specimen at 1512×1000, then re-cut a fifth taller by owner decision D28 of
 * 4 September 2026:
 *   row      grid `61px minmax(0,1fr) 108px 48px`, height 73 (canon: 51 / 86.5 / 83, height 61)
 *   clients  icon 12, figure --fs-pl-row / 700 (500 when nobody), --text-3, flush right *
 * The two FIXED tracks are re-cut, and neither is a free choice:
 *   MODE 108, against the canon's 86.5. `Własnym tempem` beside a 13px mark measures 106 at the
 *   row's own `--fs-pl-row`, and a `nowrap` run wider than its track overflows into the column on
 *   its right rather than eliding. The canon's 86.5 could not hold it either -- the specimen writes
 *   `Self-paced`, which D21 replaced with the roster's own word -- so this fixes an overflow that
 *   predates D28 rather than one it caused.
 *   LAST 48, against the canon's 83. Its content is flush RIGHT, so the track's width moves nothing
 *   a trainer sees: the figure sits on the content box's right edge whatever the track measures,
 *   and every pixel taken off it goes to the flexible name column instead. It was 35px of slack,
 *   and the name is what needed it -- at 83 a client's plan row had 105px for a name that measures
 *   126 and every one of them elided.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.row {
  grid-template-columns: var(--w-pl-cover) minmax(0, 1fr) 108px 48px;
  height: var(--h-pl-row);
}

.clients {
  display: flex;
  gap: var(--space-5px);
  align-items: center;
  justify-content: flex-end;
}

.clientsIcon {
  display: block;
  flex: none;
  width: 12px;
  height: 12px;
  color: var(--text-2);
}

/* Nobody follows this plan: the mark dims with the word. It is the canon's own pair, and the word
 * beside it says "nikt" — the state is never carried by the colour alone. */
.clientsIconIdle {
  color: var(--text-3);
}

.clientsFigure {
  flex: none;
  font-size: var(--fs-pl-row);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-3);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.clientsFigureIdle {
  font-weight: var(--fw-medium);
}
